(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tp-home-mobile-fix"] && !Shopify.designMode) return;
  try {
    
  function patchDestination(url) {
    if (url === '/collections/anthurium') return '/collections/anthurium'
    if (url === '/collections/platycerium') return '/collections/platycerium'
    return url
  }

  function patchLinks(root) {
    ;(root || document).querySelectorAll('a[href]').forEach(function (link) {
      link.setAttribute('href', patchDestination(link.getAttribute('href')))
    })
  }

  function ensureArrow(rail, className, label, text) {
    var button = rail.querySelector('.' + className)
    if (button) return button
    button = document.createElement('button')
    button.type = 'button'
    button.className = 'tp-showcase__nav ' + className
    button.setAttribute('aria-label', label)
    button.textContent = text
    rail.appendChild(button)
    return button
  }

  function bindDesktopArrows(root) {
    ;(root || document).querySelectorAll('.tp-showcase__rail').forEach(function (rail) {
      var viewport = rail.querySelector('.tp-showcase__viewport')
      var cards = rail.querySelector('.tp-showcase__cards')
      if (!viewport || !cards) return

      cards.dataset.index = '0'
      cards.style.transform = 'none'
      cards.style.transition = 'none'

      var prev = ensureArrow(rail, 'tp-showcase__nav--prev', 'Previous', '‹')
      var next = ensureArrow(rail, 'tp-showcase__nav--next', 'Next', '›')

      function amount() {
        var firstCard = cards.querySelector('.tp-product-card')
        return firstCard ? firstCard.getBoundingClientRect().width + 18 : viewport.clientWidth * 0.85
      }

      function updateButtons() {
        if (window.innerWidth < 750) {
          prev.style.display = 'none'
          next.style.display = 'none'
          return
        }
        prev.style.display = 'inline-flex'
        next.style.display = 'inline-flex'
      }

      if (prev.dataset.tpBound !== '1') {
        prev.dataset.tpBound = '1'
        prev.addEventListener('click', function (event) {
          event.preventDefault()
          viewport.scrollBy({ left: -amount() * 2, behavior: 'smooth' })
        })
      }

      if (next.dataset.tpBound !== '1') {
        next.dataset.tpBound = '1'
        next.addEventListener('click', function (event) {
          event.preventDefault()
          viewport.scrollBy({ left: amount() * 2, behavior: 'smooth' })
        })
      }

      updateButtons()
      window.addEventListener('resize', updateButtons)
    })
  }

  function ensureQuickAccessGrid(root) {
    var scope = root || document
    var grid = scope.querySelector('.tp-mobile-shortcuts__grid')
    if (!grid) return

    var existing = Array.prototype.slice.call(grid.querySelectorAll('.tp-mobile-shortcuts__item')).map(function (item) {
      return item.textContent.trim()
    })

    ;[
      { text: 'Wholesale', href: '/pages/wholesale-rare-tropical-plants' },
      { text: 'Contact', href: '/pages/contact' }
    ].forEach(function (entry) {
      if (existing.indexOf(entry.text) !== -1) return
      var link = document.createElement('a')
      link.className = 'tp-mobile-shortcuts__item'
      link.href = entry.href
      link.textContent = entry.text
      grid.appendChild(link)
    })
  }


  function repairDesktopHomeVisuals(root) {
    var scope = root || document

    ;(scope.querySelectorAll('.tp-mini-service-card__icon') || []).forEach(function (icon) {
      icon.removeAttribute('srcset')
      icon.removeAttribute('sizes')
      icon.loading = 'eager'
      icon.decoding = 'async'
      icon.style.display = 'block'
      icon.style.opacity = '1'
    })

    var strip = scope.querySelector('.tp-why-grid .tp-info-card:nth-child(2) .tp-mother-strip')
    if (!strip || strip.dataset.tpDesktopFixed === '1') return

    var photos = [
      'https://cdn.shopify.com/s/files/1/0966/6373/2531/files/anthurium_03_01_ace-of-spades-x-papi-aos-x-papi.png',
      'https://cdn.shopify.com/s/files/1/0966/6373/2531/files/anthurium_10_01_silver-king-x-skg-silver.png',
      'https://cdn.shopify.com/s/files/1/0966/6373/2531/files/anthurium_09_01_red-of-java-x-skg-silver.png',
      'https://cdn.shopify.com/s/files/1/0966/6373/2531/files/anthurium_01_01_crystallinum-no-1-x-silver-blush-no-3.png',
      'https://cdn.shopify.com/s/files/1/0966/6373/2531/files/anthurium_06_01_magnificum-x-papi-hulk.png',
      'https://cdn.shopify.com/s/files/1/0966/6373/2531/files/anthurium_05_01_papi-hulk-x-red-of-java.png',
      'https://cdn.shopify.com/s/files/1/0966/6373/2531/files/anthurium_07_01_papi-getafix-mutio-x-papi-legend.png',
      'https://cdn.shopify.com/s/files/1/0966/6373/2531/files/anthurium_04_01_crystallinum-x-silver-king.png',
      'https://cdn.shopify.com/s/files/1/0966/6373/2531/files/platycerium_01_p-white-coral-sporeling_01.png',
      'https://cdn.shopify.com/s/files/1/0966/6373/2531/files/platycerium_02_p-phoenix-sporeling_01.png',
      'https://cdn.shopify.com/s/files/1/0966/6373/2531/files/platycerium_03_p-willinckii-bigv-sporeling_01.png',
      'https://cdn.shopify.com/s/files/1/0966/6373/2531/files/platycerium_04_p-hilli-melissa-sporeling_01.png',
      'https://cdn.shopify.com/s/files/1/0966/6373/2531/files/p_veitchii_restore_previous_first.png',
      'https://cdn.shopify.com/s/files/1/0966/6373/2531/files/platycerium_06_p-wei-wei-moon-sporeling_01.png',
      'https://cdn.shopify.com/s/files/1/0966/6373/2531/files/platycerium_07_p-snow-moon-p-phoenix-mix-sporeling_01.png',
      'https://cdn.shopify.com/s/files/1/0966/6373/2531/files/platycerium_08_p-ginka-p-hillii-melissa-mix-sporeling_01.png'
    ]

    strip.dataset.tpDesktopFixed = '1'
    strip.classList.add('tp-mother-strip--repaired')
    strip.innerHTML = ''
    photos.forEach(function (url, index) {
      var tile = document.createElement('span')
      tile.className = 'tp-mother-photo'
      tile.setAttribute('role', 'img')
      tile.setAttribute('aria-label', 'Mother stock plant photo ' + (index + 1))
      tile.style.backgroundImage = 'url("' + url + '")'
      strip.appendChild(tile)
    })
  }

  function patchHome(root) {
    patchLinks(root)
    ensureQuickAccessGrid(root)
    repairDesktopHomeVisuals(root)

    window.tpUpdateCarousel = function () {}
    window.tpShiftCarousel = function () {}
    window.tpResetCarousels = function () {}

    bindDesktopArrows(root)
  }

  document.addEventListener('DOMContentLoaded', function () {
    patchHome(document)
    setTimeout(function () { patchHome(document) }, 400)
  })

  document.addEventListener('shopify:section:load', function (event) {
    patchHome(event.target || document)
  })

  window.addEventListener('load', function () {
    patchHome(document)
  })

  } catch(e) { console.error(e); }
})();
})();
